import { AlpineComponent } from "alpinejs";

type CutMeasureComponent = AlpineComponent<{
	configRequest: (event: CustomEvent) => void;
}>;

export default (): CutMeasureComponent => {
	return {
		configRequest(event: CustomEvent) {
			const parameters = event.detail.parameters;

			let cutMeasures = parseCutMeasures(parameters);

			cutMeasures = sortByIndexAsc(cutMeasures);

			const obj = cutMeasures.map((x) => {
				return { cutLength: x.measure, noOfPieces: x.quantity };
			});

			const quantity = obj.reduce((result, value) => result + parseInt(value.noOfPieces), 0);
			parameters.quantity = quantity;
			parameters.cutmeasure = JSON.stringify(obj);

			for (const key of Array.from(parameters.keys())) {
				if (/^cutmeasure\[\d+\]\.(measure|quantity)$/.test(key as string)) {
					parameters.delete(key);
				}
			}
		},
	};
};

function parseCutMeasures(formData: FormData) {
	// formData is a FormData instance
	const entries = Array.from(formData.entries()); // [ [key, value], ... ]

	// Group by index inside cutmeasure[<idx>].<prop>
	const byIndex = new Map();

	for (const [key, value] of entries) {
		// Match keys like: cutmeasure[3].quantity or cutmeasure[0].measure
		const m = key.match(/^cutmeasure\[(\d+)\]\.(measure|quantity)$/);
		if (!m) {
			continue;
		}

		const idx = Number(m[1]);
		const prop = m[2];

		if (!byIndex.has(idx)) {
			byIndex.set(idx, { index: idx, measure: undefined, quantity: undefined });
		}

		// Coerce numeric values
		const num = value === "" ? undefined : Number(value);
		byIndex.get(idx)[prop] = Number.isFinite(num) ? num?.toString() : undefined;
	}

	// Turn into array
	const rows = Array.from(byIndex.values());

	return rows;
}
function sortByIndexAsc(rows: { index: number; measure: string | undefined; quantity: string | undefined }[]) {
	return [...rows].sort((a, b) => a.index - b.index);
}
